import { AddCircle } from '@mui/icons-material';
import { Button, Grid, Paper } from '@mui/material';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getSysProducts } from 'src/shared/functions/getSysProducts';
import { SysProductYvNameEnum } from 'src/shared/models/enums/sysProductEnums';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import { InvoiceGroups } from 'src/shared/components/form/invoiceGroups';
import InvoiceMissionDataGrid from '../components/invoiceMissionDataGrid';
import { CreateMemberInvoiceStepperModal } from '../components/createMemberInvoiceStepperModal';

// Aviseringar (uppdrag) listvy
export const InvoiceMissionOverviewPage = () => {
  const { t } = useTranslation(['invoice']);
  const { currentUser } = useGlobals();
  const [, setLoading] = useState<boolean>(false);
  const [searchString] = useState<string>('');
  const [ownerId, setOwnerId] = useState<number>();
  // const [createInvoiceMissionOpen, setCreateInvoiceMissionOpen] = useState(false);
  const [showCreateMemberInvoiceModal, setShowCreateMemberInvoiceModal] = useState<boolean>(false);

  const sysProducts = getSysProducts(currentUser);
  const hasMemberReg = sysProducts.some((x) => x.yvName.toLowerCase() === SysProductYvNameEnum.MemberReg.toLowerCase());

  const loadingCallback = useCallback((isLoading: boolean) => {
    setLoading(isLoading);
  }, []);

  // const handleOpenInvoiceMissionModal = useCallback(() => {
  //   setCreateInvoiceMissionOpen(true);
  // }, []);
  // const handleCloseInvoiceMissionModal = useCallback(() => {
  //   setCreateInvoiceMissionOpen(false);
  // }, []);

  return (
    <>
      <GridWrapper>
        <Grid
          item
          xs={6}
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          <MainContentHeader title={t('invoice:Missions')} />
        </Grid>
        {hasMemberReg && (
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              onClick={() => setShowCreateMemberInvoiceModal(true)}
              variant='contained'
              color='primary'
              startIcon={<AddCircle fontSize='small' />}
              disableElevation
            >
              {t('invoice:createMemberInvoice.createMemberInvoiceButton')}
            </Button>
          </Grid>
        )}
        <Grid item xs={12}>
          <Paper>
            <PageFilterSection
              leftContent={undefined}
              rightContent={
                <InvoiceGroups
                  callback={(ownId) => {
                    setOwnerId(ownId);
                  }}
                  placeholder={t('invoice:createInvoice.selectInvoiceGroup')}
                  emptyLabel={t('invoice:createInvoice.selectInvoiceGroup')}
                  autoSelect
                  ownerId={ownerId}
                />
              }
            />
            <InvoiceMissionDataGrid loadingCallback={loadingCallback} searchString={searchString} ownerId={ownerId} />
          </Paper>
        </Grid>
      </GridWrapper>
      <CreateMemberInvoiceStepperModal modalOpen={showCreateMemberInvoiceModal} onClose={() => setShowCreateMemberInvoiceModal(false)} />
      {/* <CreateInvoiceMissionRecuringGiftModal
        onClose={handleCloseInvoiceMissionModal}
        onSave={() => ConsoleHelper.log('NOT IMPLEMENTED ??')}
        modalOpen={createInvoiceMissionOpen}
      /> */}
    </>
  );
};
